// Pause all native video, YouTube, Vimeo, product-model – matches product-information.liquid (video_tag, external_video_tag, model)
function pauseAllMedia() {
  pauseAllOtherMedia(null, null);
}
// Pause everything except skipVideo (native) and skipIframe (YT or Vimeo)
function pauseAllOtherMedia(skipVideo, skipIframe) {
  const doc = document;
  const ytPauseMsg = JSON.stringify({
    event: "command",
    func: "pauseVideo",
    args: "",
  });
  const vimeoPauseMsg = JSON.stringify({ method: "pause" });

  doc.querySelectorAll("video").forEach((v) => {
    if (v !== skipVideo) {
      try {
        v.pause();
      } catch (e) {}
    }
  });

  doc
    .querySelectorAll('.js-youtube, iframe[src*="youtube.com/embed"]')
    .forEach((el) => {
      if (el === skipIframe || !el.contentWindow) return;
      try {
        const src = (el.getAttribute("src") || "") + "";
        const ytOrigin =
          src.indexOf("youtube-nocookie") !== -1
            ? "https://www.youtube-nocookie.com"
            : "https://www.youtube.com";
        el.contentWindow.postMessage(ytPauseMsg, ytOrigin);
        el.contentWindow.postMessage(ytPauseMsg, "*");
      } catch (e) {}
    });

  doc
    .querySelectorAll('.js-vimeo, iframe[src*="player.vimeo.com"]')
    .forEach((el) => {
      if (el === skipIframe || !el.contentWindow) return;
      try {
        el.contentWindow.postMessage(vimeoPauseMsg, "https://player.vimeo.com");
      } catch (e) {}
    });

  doc.querySelectorAll("product-model").forEach((m) => {
    if (m.modelViewerUI) {
      try {
        m.modelViewerUI.pause();
      } catch (e) {}
    }
  });
}
window.pauseAllMedia = pauseAllMedia;

// When any video starts playing, pause all others (native + YT + Vimeo)
(function initMediaCoordinator() {
  if (window._fuzionMediaCoordinator) return;
  window._fuzionMediaCoordinator = true;

  function findYTIframeBySource(source) {
    let found = null;
    document
      .querySelectorAll('.js-youtube, iframe[src*="youtube.com/embed"]')
      .forEach((el) => {
        try {
          if (el.contentWindow === source) found = el;
        } catch (err) {}
      });
    return found;
  }
  function findVimeoIframeBySource(source) {
    let found = null;
    document
      .querySelectorAll('.js-vimeo, iframe[src*="player.vimeo.com"]')
      .forEach((el) => {
        try {
          if (el.contentWindow === source) found = el;
        } catch (err) {}
      });
    return found;
  }

  function isConcurrentPlaybackVideo(video) {
    return !!(
      video &&
      (video.hasAttribute("data-concurrent-playback") ||
        video.closest("[data-concurrent-playback]"))
    );
  }

  // Native <video>: play + playing (capture) so we always catch and pause others
  // Skip ambient/concurrent videos (e.g. collection list cards) so multiple can play.
  function onNativeVideoPlay(e) {
    if (e.target && e.target.tagName === "VIDEO") {
      const video = e.target;
      if (isConcurrentPlaybackVideo(video)) return;
      requestAnimationFrame(function () {
        pauseAllOtherMedia(video, null);
      });
    }
  }
  document.addEventListener("play", onNativeVideoPlay, true);
  document.addEventListener("playing", onNativeVideoPlay, true);

  // YouTube / Vimeo: react to postMessage from iframes
  window.addEventListener("message", function (e) {
    if (!e.data || !e.origin) return;
    let d;
    try {
      d = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
    } catch (err) {
      return;
    }
    if (!d || typeof d !== "object") return;

    if (e.origin.indexOf("vimeo.com") !== -1) {
      if (d.event === "ready") {
        try {
          e.source.postMessage(
            JSON.stringify({ method: "addEventListener", value: "play" }),
            "*",
          );
          e.source.postMessage(
            JSON.stringify({ method: "addEventListener", value: "playing" }),
            "*",
          );
        } catch (err) {}
      }
      if (d.event === "play" || d.event === "playing") {
        const playingVimeo = findVimeoIframeBySource(e.source);
        requestAnimationFrame(function () {
          pauseAllOtherMedia(null, playingVimeo);
        });
      }
      return;
    }

    if (e.origin.indexOf("youtube.com") !== -1) {
      const isPlaying =
        (d.event === "onStateChange" &&
          (Number(d.info) === 1 || d.info === "1")) ||
        (d.event === "infoDelivery" &&
          d.info &&
          (Number(d.info.playerState) === 1 || d.info.playerState === 1));
      if (isPlaying) {
        const playingYT = findYTIframeBySource(e.source);
        requestAnimationFrame(function () {
          pauseAllOtherMedia(null, playingYT);
        });
      }
    }
  });

  // YouTube: must send "listening" so the embed sends us state changes
  function subscribeYouTube(el) {
    if (!el || !el.contentWindow) return;
    try {
      const msg = JSON.stringify({
        event: "listening",
        id: 1,
        channel: "widget",
      });
      el.contentWindow.postMessage(msg, "*");
      el.contentWindow.postMessage(msg, "https://www.youtube.com");
      el.contentWindow.postMessage(msg, "https://www.youtube-nocookie.com");
    } catch (err) {}
  }
  function subscribeAllYouTube() {
    document
      .querySelectorAll('.js-youtube, iframe[src*="youtube.com/embed"]')
      .forEach(subscribeYouTube);
  }
  subscribeAllYouTube();
  setTimeout(subscribeAllYouTube, 500);
  setTimeout(subscribeAllYouTube, 2000);
  const ytObserver = new MutationObserver(function () {
    subscribeAllYouTube();
  });
  if (document.body)
    ytObserver.observe(document.body, { childList: true, subtree: true });

  // Subscribe existing Vimeo iframes to play events
  function subscribeVimeo(el) {
    if (!el || !el.contentWindow) return;
    try {
      el.contentWindow.postMessage(
        JSON.stringify({ method: "addEventListener", value: "play" }),
        "*",
      );
      el.contentWindow.postMessage(
        JSON.stringify({ method: "addEventListener", value: "playing" }),
        "*",
      );
    } catch (e) {}
  }
  document
    .querySelectorAll('.js-vimeo, iframe[src*="player.vimeo.com"]')
    .forEach(subscribeVimeo);
  setTimeout(function () {
    document
      .querySelectorAll('.js-vimeo, iframe[src*="player.vimeo.com"]')
      .forEach(subscribeVimeo);
  }, 2000);
})();

if (!customElements.get("fuzion-media-viewer")) {
  customElements.define(
    "fuzion-media-viewer",
    class FuzionMediaViewer extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener(
            "slideChanged",
            debounce(this.onSlideChanged.bind(this), 500),
          );
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll("[data-target]")
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector("button");
              if (button) {
                button.addEventListener(
                  "click",
                  this.setActiveMedia.bind(
                    this,
                    mediaToSwitch.dataset.target,
                    false,
                  ),
                );
              }
            });
        }
      }

      connectedCallback() {
        this._attachPauseOnSwiperSlideChange();
        setTimeout(() => this._attachPauseOnSwiperSlideChange(), 500);
        setTimeout(() => this._attachPauseOnSwiperSlideChange(), 1500);
        const onProductGalleryReady = () => {
          document.removeEventListener(
            "fuzion-product-gallery-swiper-ready",
            onProductGalleryReady,
          );
          this._attachPauseOnSwiperSlideChange();
        };
        document.addEventListener(
          "fuzion-product-gallery-swiper-ready",
          onProductGalleryReady,
        );
      }

      _attachPauseOnSwiperSlideChange() {
        const containers = this.querySelectorAll(
          ".pdp_slider, .mobile_pdp_slider, .swiper-container, .swiper",
        );
        containers.forEach((el) => {
          if (el.swiper && !el._pauseAllMediaAttached) {
            el._pauseAllMediaAttached = true;
            el.swiper.on("slideChangeTransitionEnd", () => {
              pauseAllMedia();
            });
          }
        });
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails || !event.detail.currentElement) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return; // Exit if viewer not found
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );
        if (!activeMedia) return; // Exit if media not found

        const activeMediaIndex = Array.from(
          activeMedia.parentElement.children,
        ).indexOf(activeMedia);
        const currentMedia = this.elements.viewer.querySelector(
          "[data-media-id].is-active",
        );
        const thumbnail = this.elements.thumbnails
          ? this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`)
          : null;
        const currentThumbnail = this.elements.thumbnails
          ? this.elements.thumbnails.querySelector("[data-target].is-active")
          : null;

        if (activeMedia === currentMedia) return;

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active", "is-active-order");
          });

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll("[data-target]")
            .forEach((element) => {
              element.classList.remove("is-active", "is-active-order");
            });
        }

        activeMedia.classList.add("is-active", "is-active-order");
        if (thumbnail) thumbnail.classList.add("is-active", "is-active-order");

        this.preventStickyHeader();
        if (
          this.elements.thumbnails &&
          this.elements.thumbnails.hasAttribute("is-slider") &&
          this.mql.matches &&
          thumbnail
        ) {
          requestAnimationFrame(() => {
            thumbnail.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          });
        }
        this.playActiveMedia(activeMedia);

        if (!this.elements.liveRegion) return;
        this.elements.liveRegion.setAttribute("aria-live", "polite");
        this.elements.liveRegion.textContent =
          window.accessibilityStrings.imageAvailable.replace(
            "[index]",
            activeMediaIndex + 1,
          );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute("aria-live", "off");
        }, 2000);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        thumbnail.classList.add("is-active");
      }

      playActiveMedia(activeItem) {
        pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent();
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      setActiveSlide(index) {
        this.slider = this.slider || this.querySelector(".product__media-list");
        if (!this.slider) return;

        this.slider
          .querySelectorAll(".product__media-item")
          .forEach((slide, slideIndex) => {
            slide.classList.toggle("is-active", index === slideIndex);
          });
      }
    },
  );
}

// Base ModalDialog class
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
  }
}

if (!customElements.get("modal-dialog")) {
  customElements.define("modal-dialog", ModalDialog);
}

if (!customElements.get("product-modal")) {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`,
      ).forEach((element) => {
        element.classList.remove("active");
      });
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
      );
      const activeMediaIndex = Array.from(
        activeMedia.parentElement.children,
      ).indexOf(activeMedia);
      activeMedia.classList.add("active");
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width + 40) * activeMediaIndex;
    }
  }

  customElements.define("product-modal", ProductModal);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

window.accessibilityStrings = window.accessibilityStrings || {
  imageAvailable: "Image [index] is now available in the slider",
};
